import { can } from "@/plugins/can";
import UsuariosIndexPage from "@/Pages/Usuarios/index.vue";
import NewEditUsuarioPage from "@/Pages/Usuarios/NewEditUsuarioPage.vue";
import listaDeUsuariosParaBloquearLiberar from "@/Pages/Usuarios/listaDeUsuariosParaBloquearLiberar.vue";
import RecursosHumanosUsuarioPage from "../Pages/Usuarios/RecursosHumanosUsuarioPage.vue";

const checkPermission = (permissions) => {
  return (to, from, next) => {
    if (!can(permissions)) {
      return next({ name: "NaoAutorizado" });
    }
    return next();
  };
};

export default [
  {
    path: "/usuarios/",
    name: "usuarios",
    component: UsuariosIndexPage,
    beforeEnter: checkPermission(["users.*"]),
  },
  {
    path: "/usuarios/create",
    name: "usuarios.create",
    component: NewEditUsuarioPage,
    props: { editing: false },
  },
  {
    path: "/usuarios/edit/:usuario_id",
    name: "usuarios.edit",
    component: NewEditUsuarioPage,
    props: { editing: true },
  },
  {
    path: "/usuarios/listaDeUsuariosParaBloquearLiberar",
    name: "usuarios.listaDeUsuariosParaBloquearLiberar",
    component: listaDeUsuariosParaBloquearLiberar,
    beforeEnter: checkPermission(["users.*"]),
  },
  {
    path: "/usuarios/recursosHumanos/:usuario_id",
    name: "usuarios.recursosHumanos",
    component: RecursosHumanosUsuarioPage,
  },
];
